// extracted by mini-css-extract-plugin
export var cardHeader = "_gr-0";
export var reorderHandle = "_gr-3";
export var titleArea = "_gr-1";
export var titleAreaWithHandle = "_gr-2";